export type FixedCtaMock = {
    buttonLabel: string;
    ariaLabel: string;
    hideZoneIds: readonly string[];
};

export const fixedCtaMock: FixedCtaMock = {
    buttonLabel: 'Get in touch',
    ariaLabel: 'Get in touch',
    hideZoneIds: ['home', 'want-to-know-more', 'experience-cta'],
};
